import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {DragDropModule} from '@angular/cdk/drag-drop';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import { AdicionalComponent } from './adicional.component';

import { PreguntasComponent } from './preguntas/preguntas.component';
import { PreguntaComponent } from './preguntas/pregunta/pregunta.component';
import { AbiertaComponent } from './preguntas/pregunta/abierta/abierta.component';
import { OpcionesComponent } from './preguntas/pregunta/opciones/opciones.component';

import { TraduccionesComponent } from './traducciones/traducciones.component';
import { TablaComponent } from './traducciones/tabla/tabla.component';

import { PreviewComponent } from './preview/preview.component';

import { TemplatesComponent } from './templates/templates.component';

import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';

// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    AdicionalComponent,

    PreguntasComponent,
    PreguntaComponent,
    AbiertaComponent,
    OpcionesComponent,
    TraduccionesComponent,
    TablaComponent,
    PreviewComponent,
    TemplatesComponent,
  ],
  imports: [
    CommonModule,
    DragDropModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatTabsModule,
    MatTooltipModule,
    MatSelectModule,
    MatSnackBarModule,
    MatStepperModule,
    ReactiveFormsModule,
    TranslateModule,
    MatProgressSpinnerModule,
    MatListModule,
    MatDividerModule,
    MatRadioModule,
    MatTableModule
  ],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: {
        displayDefaultIndicatorType: false,
        showError: true
      }
    }
  ]
})
export class AdicionalesModule { }
